export default __webpack_public_path__ + "static/viewpoint-f547e9741e7b940ecc50d88d6a3eaf06.jpg";